export default __webpack_public_path__ + "static/media/landingHero.be1d232c.png";